export default __webpack_public_path__ + "static/B19-d6ee3f4f275362d5f9d4ece7b9bbe0c9.png";